<template>
    <CContainer>
        <h3>Dashboard de Productos</h3>
    </CContainer>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'

export default {
    name: "DashboardProducts",
    setup() {

    },
    data() {
        return {

        }
    },
    components: {

    },
    methods: {

    },
    computed: {

    },
    mounted() {

    }
}
</script>
